import React, { createContext, useState, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { makeStyles } from "@material-ui/core/styles";
import "./Table.css";
import "./common-style.css";
import "bootstrap/dist/css/bootstrap.css";
//Material
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Box from "@material-ui/core/Box";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
//Component

//Function

const col = [
  {
    dataField: "id",
    text: "id",
    sort: true,
    //align: 'center',
    //events: onClickCol,
  },
  {
    dataField: "name",
    text: "Name",
    sort: true,
    //align: 'center',
    //events: onClickCol,
  },
];

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 40,
  },
  selectControl: {
    maxHeight: 30,
    marginTop: "-10px",
  },
  labelSizeperpage: {
    fontSize: 16,
  },
  rootSearch: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    width: 400,
  },
  rootButton: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    width: 150,
  },
  searchText: {
    textAlign: "-webkit-right",
  },
  iconButton: {
    // padding: 10,
    backgroundColor: "#000",
    color: "#fff",
  },
  iconButtonAddDelete: {
    // padding: 10,
    backgroundColor: "#000",
    color: "#fff",
    marginRight: theme.spacing(2),
  },
  divider: {
    height: 28,
    margin: 4,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    border: 0,
  },
}));

const checkexistsId = (arr, id) => {
  return Array.isArray(arr) && arr.length && arr.find((el) => el.id === id);
};
const MyExportCSV = (props) => {
  const handleClick = () => {
    props.onExport();
  };
  return (
    <div>
      <button className="btn btn-success" onClick={handleClick}>
        Export To CSV
      </button>
    </div>
  );
};
const searchStyle = { width: "400px" };
export const ReactBootStrapTable = ({
  id,
  clickToSelect = false,
  clickRowToSelect = false,
  handleOnSelect,
  handleOnSelectAll,
  headcomponent = () => {
    return <></>;
  },
  exportCsv = false,
  disableSelectable,
  selectOptions,
  selectedRow,
  showSearch = true,
  selectStyle,
  headRightcomponent = () => {
    return <></>;
  },
  addButton = false,
  handleOnAdd,
  keepStateSearch = false,
  ...props
}) => {
  //console.log(disableSelectable);
  for (let index = 0; index < props.columns.length; index++) {
    props.columns[index] = {
      ...props.columns[index],
      sortCaret: (order) => {
        if (!order) return "";
        else if (order === "asc") return <ArrowDropUpIcon />;
        else if (order === "desc") return <ArrowDropDownIcon />;
        return null;
      },
    };
  }

  const classes = useStyles();
  const { SearchBar } = Search;
  const context = useContext(ReactTableContext);
  const selectRow = {
    mode: "checkbox",
    clickToSelect: clickRowToSelect,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    style: selectStyle,
    nonSelectable: disableSelectable,
    //nonSelectableClasses: 'disabled',
    selected: selectedRow,
    ...selectOptions,
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <div>
      <span className={classes.labelSizeperpage}>Item per page : </span>
      <FormControl variant="outlined" className={classes.formControl}>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          value={currSizePerPage}
          onChange={(e) => onSizePerPageChange(e.target.value)}
          autoWidth
          className={classes.selectControl}
        >
          {options.map((option) => (
            <MenuItem key={option.text} value={option.text}>
              {option.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );

  const options = {
    sizePerPageRenderer,
    onPageChange: (e) => {
      console.log(e);
      if (!id) return;
      if (!context) return;
      if (checkexistsId(context.myProperties, id)) {
        let idx = context.myProperties.findIndex(
          (element) => element.id === id
        );
        let newArray = [...context.myProperties];
        newArray[idx] = { ...newArray[idx], page: e };
        context.setmyProperties(newArray);
      } else {
        let newArray = [...context.myProperties].concat({ page: e, id });
        context.setmyProperties(newArray);
      }
    },
    onSizePerPageChange: (e) => {
      console.log(e);
      if (!id) return;
      if (!context) return;
      if (checkexistsId(context.myProperties, id)) {
        let idx = context.myProperties.findIndex(
          (element) => element.id === id
        );
        let newArray = [...context.myProperties];
        newArray[idx] = { ...newArray[idx], sizePerPage: e };
        context.setmyProperties(newArray);
      } else {
        let newArray = [...context.myProperties].concat({
          sizePerPage: e,
          Page: 1,
          id,
        });
        context.setmyProperties(newArray);
      }
    },
    sizePerPage:
      (context &&
        context.myProperties.find((el) => el.id === id) &&
        context.myProperties.find((el) => el.id === id).sizePerPage) ||
      30,
    page:
      context &&
      context.myProperties.find((el) => el.id === id) &&
      context.myProperties.find((el) => el.id === id).page,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  const MySearch = (props) => {
    let input;
    const handleClick = () => {
      localStorage.setItem("SearchTable", input.value);
      props.onSearch(input.value);
    };

    const handleEnter = (e) => {
      //console.log(input.value);
      if (e.keyCode === 13) {
        localStorage.setItem("SearchTable", input.value);
        props.onSearch(input.value);
        e.preventDefault();
      }
    };
    const style = {
      control: (base) => ({
        ...base,
        border: 0,
        // This line disable the blue border
        boxShadow: "none",
      }),
    };
    return (
      <Paper component="form" className={classes.rootSearch}>
        <input
          className={classes.input}
          placeholder="Search"
          style={{ outline: "none" }}
          ref={(n) => (input = n)}
          onKeyDown={(e) => handleEnter(e)}
          defaultValue={
            keepStateSearch ? localStorage.getItem("SearchTable") : input
          }
        />

        <Divider className={classes.divider} orientation="vertical" />
        <Button
          variant="contained"
          className={classes.iconButton}
          onClick={() => handleClick()}
        >
          Search
        </Button>
      </Paper>
    );
  };

  return (
    <>
      <ToolkitProvider
        keyField={props.keyField || "id"}
        data={props.data || []}
        columns={props.columns || col}
        bordered={false}
        search
      >
        {(innerprops) => (
          <div className="reactTable-common">
            <Box display="flex" flexDirection="row" alignItems="center">
              <Grid item xs={12} container spacing={1}>
                <Grid item xs={8} container spacing={1}>
                  <Grid item xs={12} className={classes.buttonGrid}>
                    {headcomponent()}
                    {addButton ? (
                      <Button
                        variant="contained"
                        className={classes.iconButtonAddDelete}
                        onClick={() => handleOnAdd()}
                      >
                        Add
                      </Button>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={4} className={classes.searchText}>
                  {headRightcomponent(innerprops.searchProps)}
                  {showSearch ? (
                    <MySearch style={searchStyle} {...innerprops.searchProps} />
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Box flexGrow={1}></Box>

              {exportCsv ? <MyExportCSV {...innerprops.csvProps} /> : null}
            </Box>
            {clickToSelect ? (
              <BootstrapTable
                {...innerprops.baseProps}
                {...props}
                selectRow={selectRow}
                noDataIndication="Data have 0 record"
                bodyStyle={{ wordBreak: "break-all" }}
                //onDataSizeChange={()=>{context.setmyProperties()}}
                pagination={paginationFactory(options)}
              />
            ) : (
              <BootstrapTable
                {...innerprops.baseProps}
                {...props}
                noDataIndication="Data have 0 record"
                bodyStyle={{ wordBreak: "break-all" }}
                //onDataSizeChange={()=>{context.setmyProperties()}}
                pagination={paginationFactory(options)}
              />
            )}
          </div>
        )}
      </ToolkitProvider>
      Total items : {props.data && props.data.length} rows
    </>
  );
};
export const ReactTableContext = createContext();
export const ReactTableContextProvider = ({ children }) => {
  const [myProperties, setmyProperties] = useState([]);
  return (
    <ReactTableContext.Provider value={{ myProperties, setmyProperties }}>
      {children}
    </ReactTableContext.Provider>
  );
};
ReactBootStrapTable.propTypes = {};
export default ReactBootStrapTable;
